import React, { CSSProperties } from "react";
import classNames from "classnames";
import styles from "./Skeleton.stylesheet.module.scss";

interface SkeletonProps {
  className?: string;
  height?: CSSProperties["height"];
  radius?: CSSProperties["borderRadius"];
  width?: CSSProperties["width"];
}

export const Skeleton = ({
  className,
  height,
  radius,
  width,
}: SkeletonProps) => (
  <span
    aria-hidden="true"
    className={classNames(styles.skeleton, className)}
    style={{
      borderRadius: radius,
      height,
      width,
    }}
  />
);
